module.exports = __webpack_public_path__ + "assets/bingbao.c6b8fbdf.svg";